import { render, staticRenderFns } from "./ProductsSearch.vue?vue&type=template&id=1f45e4ca&scoped=true"
import script from "./ProductsSearch.vue?vue&type=script&lang=js"
export * from "./ProductsSearch.vue?vue&type=script&lang=js"
import style0 from "./ProductsSearch.vue?vue&type=style&index=0&id=1f45e4ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f45e4ca",
  null
  
)

export default component.exports